import React from 'react'
import { CSSTransition } from 'react-transition-group'
import { EIconSize, Icon } from '@frontend/pole-ui/lib/components/Icon'
import { ExitIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ExitIcon'
import Overlay from '@/components/composed/Overlay/Overlay'
import Portal from '@/components/composed/Portal'
import { Android } from '@/components/composed/pwa/Notification/components/Android/Android'
import { Ios } from '@/components/composed/pwa/Notification/components/Ios/Ios'
import { Header } from '../Header/Header'
import type { IComponentProps } from '../types'
import '../styles.scss'

export const NotificationModal = (props: IComponentProps) => {
  const { isOpen, onClose, onInstallApp, isIos } = props

  return (
    <Portal>
      <CSSTransition appear mountOnEnter unmountOnExit in={isOpen} timeout={200} classNames="fading">
        <Overlay onClick={onClose} />
      </CSSTransition>

      <CSSTransition appear mountOnEnter unmountOnExit in={isOpen} timeout={200}>
        <div className="notification__dialog">
          <div className="notification__dialogHeader">
            <Header isPoleLogo={isIos} />
            <div onClick={onClose} className="notification__dialogClose">
              <Icon component={<ExitIcon />} size={EIconSize.M} />
            </div>
          </div>
          <div className="notification__dialogBody">
            {isIos ? <Ios onActionButtonClick={onClose} /> : <Android onActionButtonClick={onInstallApp} />}
          </div>
        </div>
      </CSSTransition>
    </Portal>
  )
}
